import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogTrigger,
        DialogBody,
    } from '@/components/ui/dialog';
    import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
        AlertDialogTrigger,
    } from '@/components/ui/alert-dialog';
    import { computed, ref } from 'vue';
    import { toast } from 'vue-sonner';
    import { useForm, usePage } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import type { SharedData, Employee } from '@/types';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import { useVoucherStore } from '@/stores/voucher';
    import VoucherMarkAsMissingForm from '@/components/vouchers/VoucherMarkAsMissingForm.vue';
    import type { Table } from '@tanstack/vue-table';
    import RemoveButton from '../RemoveButton.vue';
    import { InputRow, DatePicker } from '@/components/ui/form';
    import { Minus } from 'lucide-vue-next';
    import { today, getLocalTimeZone } from '@internationalized/date';
    import { useDateFormat } from '@/composables/useDateFormat';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TerminateEmployee',
  props: {
    employee: {}
  },
  setup(__props: any) {

    const { formatDMYFromIso } = useDateFormat();

    const props = __props;

    const { t } = useI18n();

    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);
    const queryClient = useQueryClient();

    const isConfirmationDialogOpen = ref(false);
    const isDialogOpen = ref(false);
    const isCancelDialogOpen = ref(false);

    const form = useForm({
        id: props.employee.id,
        termination_date: props.employee.termination
            ? props.employee.termination.termination_date
            : today(getLocalTimeZone()).toString(),
    });

    const terminate = () => {
        form.post(route('v2.salary.employee.terminate.create'), {
            preserveScroll: true,
            onSuccess: () => {
                form.resetAndClearErrors();
                toast.success(
                    t('termination.success-msg', {
                        name: props.employee.full_name,
                        date: formatDMYFromIso(form.termination_date),
                    }),
                );
                queryClient.invalidateQueries({ queryKey: [QueryKey.EMPLOYEES, companyId] });
                isDialogOpen.value = false;
            },
            onError: (error: any) => {
                toast.error(error.error);
            },
        });
    };

    const showConfirmationDialog = () => {
        isConfirmationDialogOpen.value = true;
    };

    const showCancelDialog = () => {
        isCancelDialogOpen.value = true;
    };

    const { mutate, isPending } = useMutation({
        mutationFn: () =>
            axios.post(
                route('v2.salary.employee.terminate.cancel', {
                    employeeId: props.employee.id,
                }),
            ),
        onSuccess: (data) => {
            toast.success(data.data.success || t('forms.general.success'));
            queryClient.invalidateQueries({ queryKey: [QueryKey.EMPLOYEES, companyId] });
            isDialogOpen.value = false;
        },
        onError: (error: any) => {
            toast.error(error.response.data.error || t('forms.system_error'));
        },
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: isDialogOpen.value,
    "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((isDialogOpen).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: _ctx.employee.termination ? 'continue' : 'delete',
            size: "sm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.employee.termination
                        ? _unref(t)('termination.table.btns.terminated')
                        : _unref(t)('termination.table.btns.dismiss')) + " ", 1),
              _createVNode(_unref(Minus))
            ]),
            _: 1
          }, 8, ["variant"])
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(terminate, ["prevent"]),
            class: "flex max-h-full flex-col overflow-hidden"
          }, [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('termination.js.input_title')) + " " + _toDisplayString(_ctx.employee.full_name), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogBody), null, {
              default: _withCtx(() => [
                _createVNode(_unref(InputRow), {
                  form: _unref(form),
                  name: "termination_date",
                  label: "employee.termination.termination_date"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DatePicker), {
                      modelValue: _unref(form).termination_date,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).termination_date) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["form"])
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
              default: _withCtx(() => [
                (_ctx.employee.termination)
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      onClick: _withModifiers(showCancelDialog, ["prevent"]),
                      variant: "delete",
                      size: "sm",
                      class: "mr-auto"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('termination.cancel-termination')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(DialogClose), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      size: "sm",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(form).resetAndClearErrors()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('forms.cancel')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: _unref(form).processing,
                  loading: _unref(form).processing,
                  size: "sm",
                  onClick: _withModifiers(showConfirmationDialog, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('forms.save')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      }),
      _createVNode(_unref(AlertDialog), {
        open: isConfirmationDialogOpen.value,
        "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((isConfirmationDialogOpen).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AlertDialogContent), { class: "sm:max-w-md" }, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(AlertDialogTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('termination.js.confirm_title')) + " " + _toDisplayString(_ctx.employee.full_name), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AlertDialogDescription), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('termination.js.confirm_msg')) + " " + _toDisplayString(_ctx.employee.full_name) + " pr. " + _toDisplayString(_unref(formatDMYFromIso)(_unref(form).termination_date)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(AlertDialogFooter), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(AlertDialogCancel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('termination.js.no')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AlertDialogAction), {
                    onClick: terminate,
                    variant: "default"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('termination.js.yes')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"]),
      (_ctx.employee.termination)
        ? (_openBlock(), _createBlock(_unref(AlertDialog), {
            key: 0,
            open: isCancelDialogOpen.value,
            "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((isCancelDialogOpen).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(AlertDialogContent), { class: "sm:max-w-md" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AlertDialogHeader), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AlertDialogTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('termination.js.undo_title')) + " " + _toDisplayString(_ctx.employee.full_name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(AlertDialogDescription), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('termination.js.undo_msg')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AlertDialogFooter), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AlertDialogCancel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('termination.js.no')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(AlertDialogAction), {
                        onClick: _unref(mutate),
                        variant: "default"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('termination.js.yes')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["open"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})